import { forwardRef } from 'react'

import { clsx } from 'clsx'

import { ColorCircleSize } from './types.js'

export type ColorCircleProps = {
  color: string
  size?: ColorCircleSize
  onClick?: () => void
  invalid?: boolean
  disabled?: boolean
  className?: string
}

export const ColorCircle = forwardRef<HTMLButtonElement, ColorCircleProps>(
  (
    {
      color,
      size = 'md',
      onClick,
      invalid = false,
      className,
      ...rest
    }: ColorCircleProps,
    ref,
  ) => {
    return (
      <button
        type="button"
        ref={ref}
        className={clsx(
          'rounded-full border border-line',
          'shrink-0',
          invalid && 'ring ring-line-negative',
          onClick ? 'hover:border-line' : 'cursor-default',
          size === 'xs' && 'h-4 w-4',
          size === 'sm' && 'h-5 w-5',
          size === 'md' && 'h-8 w-8',
          size === 'lg' && 'h-10 w-10',
          className,
        )}
        style={{
          backgroundColor: color,
        }}
        onClick={onClick}
        {...rest}
      />
    )
  },
)
